import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Observable, of} from "rxjs";
import {Select} from "@ngxs/store";
import {SharedState} from "@sharedAl/store";

@Component({
  selector: 'cl-technical-error',
  templateUrl: './technical-error.component.html',
  styleUrls: ['../layout/error.component.scss']
})
export class TechnicalErrorComponent implements OnInit {

  errorMessages: string[];

  email: Observable<string>;

  @Select(SharedState.brand)
  private getBrand$: Observable<string>;

  ngOnInit() {
    this.email = of("szkody@generali.pl");
  }

  constructor(private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    if (navigation && navigation.extras && navigation.extras.state && navigation.extras.state.messages) {
      this.errorMessages = this.router.getCurrentNavigation().extras.state.messages as string[];
    } else {
      this.router.navigateByUrl("/");
    }
  }

}

